"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInputOption = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const utils_1 = require("../utils");
const SelectInputContext_1 = require("./SelectInputContext");
const Dropdown_1 = require("../../../Dropdown");
const activeStyle = (0, app_1.css) `
  background: ${(theme) => theme.colors.gray.intense};
`;
const StyledChoice = app_1.styled.label `
  cursor: pointer;
  display: block;
  ${(theme) => app_1.styled.checked `
    background-color: ${theme.colors.gray.intense};
  `}
`;
function SelectInputOption({ value, onClick, className, children, }) {
    const id = (0, app_1.useCuid)();
    const choiceContext = (0, react_1.useContext)(SelectInputContext_1.SelectInputContext);
    if (!choiceContext) {
        throw new Error('SelectInput.Option must be used inside SelectInput');
    }
    const { onChange, value: checked } = choiceContext;
    const handleChange = () => onChange(value);
    const isChecked = Array.isArray(checked)
        ? checked.includes(value)
        : checked === value;
    const dropdownElementStyle = (0, react_1.useMemo)(() => (0, app_1.css) `
      ${isChecked && activeStyle}
    `, [isChecked]);
    return ((0, jsx_runtime_1.jsx)(Dropdown_1.Dropdown.Element, Object.assign({ css: dropdownElementStyle, onClick: handleChange }, { children: (0, jsx_runtime_1.jsxs)(StyledChoice, Object.assign({ onClick: onClick, tabIndex: 0, className: className, onKeyDown: (ev) => /^(Enter| )$/u.test(ev.key) && ev.currentTarget.click(), htmlFor: id }, (0, utils_1.aria)({ checked: isChecked }), { children: [(0, jsx_runtime_1.jsx)(utils_1.StyledHiddenCheckbox, { id: id, tabIndex: -1, type: "checkbox", checked: isChecked, onChange: handleChange }), children] })) })));
}
exports.SelectInputOption = SelectInputOption;
